import { behaviorChoices, bindCtaSelects } from "#/admin/legacy/page-builder/behavior-tool.js";
import "#legacy/admin/page_builder/tool.js";
/**
 * Load lifecycle:
 *  tool.setState - used by tools with more complicated state requirements. Most tools just pass the component context to their templates, so that's the default
 *  tool.render - by default updates the tool element with markup generated by tool template, overrid for react apps
 *  tool.bind - bind events to the tool or component here
 *  tool.unbind - unbind any events
 *
 * Update lifecycle
 *  tool.setState
 *  tool.update
 *  tool.rendered (if the component was rendered)
 *
 * General Notes
 *  - render/bind/unbind are only called on load, after that it's setcontext and update. update is
 *  - identical to render by default, but you can override it. the update lifecycle is only triggered if
 *  - another tool changes the splinter, so if your tool changes a context value, you update your view there.
 */

(function () {
  "use strict";

  Sparkle.PageBuilder.Tool({
    /**
     * @description Unique identifier for the tool component.
     */
    name: "behavior",

    /**
     * @description The template file to use to load and render the component.
     * @see settings-editor-template.hbs
     */
    templateId: "behavior-editor-template",

    /**
     * @override
     * @name shouldLoad
     * @description
     *  Return whether or not this tool should always load. In this case,
     *   because this tool will always need to load for every tool, we want
     *   to go ahead and force the loading.
     * @return {boolean}
     */
    shouldLoad: function () {
      return true;
    },

    /**
     * @override
     * @name render
     * @description
     *  Render the tool component using the built in template renderer. This is
     *   an override of the base component render, and will use special properties
     *   not usually accessed by other tools.
     * @param {HTMLElement} element
     */
    render: function (element) {
      element = element || this.element;

      if (this.template && this.element) {
        var markup = this.template({
          ...behaviorChoices(window.SparkleConfig.callToAction.selectItems, this.component),
          inheritable: this.component.data("inheritable"),
          sticky: this.component.data("sticky"),
          cta: this.component.data("type") === "CallToAction",
          cta_teaser_button_text: this.component.data("cta_teaser_button_text"),
          targeting: this.component.data("targeting"),
          targeting_segment: this.component.data("targeting_segment"),
          campaignTargeting: window.RESOURCE.campaignTargeting,
        });
        element.innerHTML = markup;
      }
    },

    /**
     * @name bind
     * @description
     * Bind the different event listeners to the component, and also add in
     *  any extra functionality to manage the slideshow
     * @param {HTMLElement} component
     */
    bind: function (component) {
      var me = this,
        $rootElement = jQuery(this.element);

      // Inheritable
      $rootElement.find("input[name=inheritable]").on("change", function () {
        var checked = jQuery(this).is(":checked");
        me.component.data("inheritable", checked);
        me.component.save();
        me.component.renderActionBar();
      });

      // CTA category and replacement strategy
      bindCtaSelects(this.element, me.component);

      // if the user adds a CTA teaser button text, then save it
      $rootElement.find("#cta_teaser_button_text").on("change", function () {
        me.component.data("cta_teaser_button_text", jQuery(this).val());
      });

      // CTA options
      $rootElement.find(".cta-options").toggle(me.component.data("type") == "CallToAction");

      // Sticky (for CTAs only)
      $rootElement.find("input#sticky").on("change", function () {
        var checked = jQuery(this).is(":checked");
        me.component.data("sticky", checked);
        me.component.save();
      });

      // Targeting and Targeting Options
      $rootElement.find(".targeting-options").toggle(me.component.data("targeting"));

      $rootElement.find("input#targeting").on("change", function () {
        var checked = jQuery(this).is(":checked");
        updateTargetingOptions(checked);
        me.component.save();
      });

      function updateTargetingOptions(checked) {
        $rootElement.find(".targeting-options").toggle(checked);
        me.component.setTargeting(checked);
      }

      // Targeting Segments
      $rootElement.find("input[data-targeting-segment-condition]").on("change", function () {
        var checked = jQuery(this).is(":checked");
        var targetingSegment = me.component.data("targeting_segment");
        var condition = jQuery(this).data("targeting-segment-condition");
        targetingSegment[condition] = checked;

        // Technically we've just finished modifying `targeting_segment` by reference, but save anyway in case it does some extra work
        me.component.data("targeting_segment", targetingSegment);
        me.component.save();
      });
    },
  });
})();
